import { GetTransferFilePreviewOutput } from '@smash-sdk/transfer/ejs/01-2024';
import { TransferFileType, PreviewableTransferFileExtension, TransferFile, TransferFileProvider } from '../models/transferFile';

const previewableTransferFile: { extension: PreviewableTransferFileExtension, type: TransferFileType, previewable: boolean }[] = [
    { extension: '.jpg', type: 'image', previewable: true },
    { extension: '.jpeg', type: 'image', previewable: true },
    { extension: '.png', type: 'image', previewable: true },
    { extension: '.gif', type: 'image', previewable: true },
    { extension: '.bmp', type: 'image', previewable: false },
    { extension: '.tiff', type: 'image', previewable: false },
    { extension: '.tif', type: 'image', previewable: false },
    { extension: '.webp', type: 'image', previewable: true },
    { extension: '.svg', type: 'image', previewable: true },
    { extension: '.heic', type: 'image', previewable: false },
    { extension: '.heif', type: 'image', previewable: false },
    { extension: '.raw', type: 'image', previewable: false },
    { extension: '.psd', type: 'image', previewable: false },
    { extension: '.ico', type: 'image', previewable: false },
    { extension: '.eps', type: 'image', previewable: false },
    { extension: '.ai', type: 'image', previewable: false },
    { extension: '.indd', type: 'image', previewable: false },
    { extension: '.cr2', type: 'image', previewable: false },
    { extension: '.nef', type: 'image', previewable: false },
    { extension: '.orf', type: 'image', previewable: false },
    { extension: '.dng', type: 'image', previewable: false },
    { extension: '.arw', type: 'image', previewable: false },
    { extension: '.raf', type: 'image', previewable: false },
    { extension: '.sr2', type: 'image', previewable: false },
    { extension: '.3fr', type: 'image', previewable: false },
    { extension: '.bay', type: 'image', previewable: false },
    { extension: '.kdc', type: 'image', previewable: false },
    { extension: '.mrw', type: 'image', previewable: false },
    { extension: '.pef', type: 'image', previewable: false },
    { extension: '.x3f', type: 'image', previewable: false },
    { extension: '.rwl', type: 'image', previewable: false },
    { extension: '.rw2', type: 'image', previewable: false },
    { extension: '.srw', type: 'image', previewable: false },
    { extension: '.mef', type: 'image', previewable: false },
    { extension: '.mos', type: 'image', previewable: false },
    { extension: '.iiq', type: 'image', previewable: false },
    { extension: '.ciff', type: 'image', previewable: false },
    { extension: '.ppm', type: 'image', previewable: false },
    { extension: '.pgm', type: 'image', previewable: false },
    { extension: '.pbm', type: 'image', previewable: false },
    { extension: '.pnm', type: 'image', previewable: false },
    { extension: '.hdr', type: 'image', previewable: false },
    { extension: '.exr', type: 'image', previewable: false },
    { extension: '.jpf', type: 'image', previewable: false },
    { extension: '.jpx', type: 'image', previewable: false },
    { extension: '.j2k', type: 'image', previewable: false },
    { extension: '.jp2', type: 'image', previewable: false },
    { extension: '.mp3', type: 'audio', previewable: true },
    { extension: '.wav', type: 'audio', previewable: true },
    { extension: '.aac', type: 'audio', previewable: false },
    { extension: '.flac', type: 'audio', previewable: false },
    { extension: '.ogg', type: 'audio', previewable: false },
    { extension: '.wma', type: 'audio', previewable: false },
    { extension: '.m4a', type: 'audio', previewable: true },
    { extension: '.alac', type: 'audio', previewable: false },
    { extension: '.aiff', type: 'audio', previewable: false },
    { extension: '.aif', type: 'audio', previewable: false },
    { extension: '.aifc', type: 'audio', previewable: false },
    { extension: '.opus', type: 'audio', previewable: false },
    { extension: '.pcm', type: 'audio', previewable: false },
    { extension: '.amr', type: 'audio', previewable: false },
    { extension: '.ape', type: 'audio', previewable: false },
    { extension: '.wv', type: 'audio', previewable: false },
    { extension: '.ra', type: 'audio', previewable: false },
    { extension: '.mka', type: 'audio', previewable: false },
    { extension: '.mid', type: 'audio', previewable: false },
    { extension: '.midi', type: 'audio', previewable: false },
    { extension: '.au', type: 'audio', previewable: false },
    { extension: '.dss', type: 'audio', previewable: false },
    { extension: '.dsf', type: 'audio', previewable: false },
    { extension: '.dff', type: 'audio', previewable: false },
    { extension: '.caf', type: 'audio', previewable: false },
    { extension: '.vox', type: 'audio', previewable: false },
    { extension: '.tta', type: 'audio', previewable: false },
    { extension: '.mogg', type: 'audio', previewable: false },
    { extension: '.8svx', type: 'audio', previewable: false },
    { extension: '.mpc', type: 'audio', previewable: false },
    { extension: '.ac3', type: 'audio', previewable: false },
    { extension: '.adt', type: 'audio', previewable: false },
    { extension: '.adts', type: 'audio', previewable: false },
    { extension: '.ast', type: 'audio', previewable: false },
    { extension: '.snd', type: 'audio', previewable: false },
    { extension: '.gsm', type: 'audio', previewable: false },
    { extension: '.raw', type: 'audio', previewable: false },
    { extension: '.swa', type: 'audio', previewable: false },
    { extension: '.rmi', type: 'audio', previewable: false },
    { extension: '.thd', type: 'audio', previewable: false },
    { extension: '.sbk', type: 'audio', previewable: false },
    { extension: '.sf2', type: 'audio', previewable: false },
    { extension: '.it', type: 'audio', previewable: false },
    { extension: '.mod', type: 'audio', previewable: false },
    { extension: '.s3m', type: 'audio', previewable: false },
    { extension: '.xm', type: 'audio', previewable: false },
    { extension: '.mp4', type: 'video', previewable: true },
    { extension: '.ogg', type: 'video', previewable: true },
    { extension: '.avi', type: 'video', previewable: false },
    { extension: '.mkv', type: 'video', previewable: false },
    { extension: '.mov', type: 'video', previewable: true },
    { extension: '.wmv', type: 'video', previewable: false },
    { extension: '.flv', type: 'video', previewable: false },
    { extension: '.webm', type: 'video', previewable: true },
    { extension: '.m4v', type: 'video', previewable: false },
    { extension: '.vob', type: 'video', previewable: false },
    { extension: '.3gp', type: 'video', previewable: false },
    { extension: '.ts', type: 'video', previewable: false },
    { extension: '.mxf', type: 'video', previewable: false },
    { extension: '.divx', type: 'video', previewable: false },
    { extension: '.ogv', type: 'video', previewable: false },
    { extension: '.asf', type: 'video', previewable: false },
    { extension: '.f4v', type: 'video', previewable: false },
    { extension: '.m2ts', type: 'video', previewable: false },
    { extension: '.mts', type: 'video', previewable: false },
    { extension: '.dv', type: 'video', previewable: false },
    { extension: '.swf', type: 'video', previewable: false },
    { extension: '.mpe', type: 'video', previewable: false },
    { extension: '.mpv', type: 'video', previewable: false },
    { extension: '.m2v', type: 'video', previewable: false },
    { extension: '.amv', type: 'video', previewable: false },
    { extension: '.qt', type: 'video', previewable: false },
    { extension: '.svi', type: 'video', previewable: false },
    { extension: '.drc', type: 'video', previewable: false },
    { extension: '.xvid', type: 'video', previewable: false },
    { extension: '.m1v', type: 'video', previewable: false },
    { extension: '.3g2', type: 'video', previewable: false },
    { extension: '.nut', type: 'video', previewable: false },
    { extension: '.vid', type: 'video', previewable: false },
    { extension: '.yuv', type: 'video', previewable: false },
    { extension: '.roq', type: 'video', previewable: false },
    { extension: '.ivf', type: 'video', previewable: false },
    { extension: '.gvi', type: 'video', previewable: false },
    { extension: '.viv', type: 'video', previewable: false },
    { extension: '.rmvb', type: 'video', previewable: false },
    { extension: '.rm', type: 'video', previewable: false },
    { extension: '.mjp', type: 'video', previewable: false },
    { extension: '.mj2', type: 'video', previewable: false },
    { extension: '.mpg', type: 'video', previewable: false },
    { extension: '.mpeg', type: 'video', previewable: false },
    { extension: '.doc', type: 'document', previewable: false },
    { extension: '.docx', type: 'document', previewable: false },
    { extension: '.pdf', type: 'document', previewable: false },
    { extension: '.txt', type: 'document', previewable: false },
    { extension: '.xls', type: 'document', previewable: false },
    { extension: '.xlsx', type: 'document', previewable: false },
    { extension: '.ppt', type: 'document', previewable: false },
    { extension: '.pptx', type: 'document', previewable: false },
    { extension: '.odt', type: 'document', previewable: false },
    { extension: '.ods', type: 'document', previewable: false },
    { extension: '.odp', type: 'document', previewable: false },
    { extension: '.rtf', type: 'document', previewable: false },
    { extension: '.csv', type: 'document', previewable: false },
    { extension: '.md', type: 'document', previewable: false },
    { extension: '.epub', type: 'document', previewable: false },
    { extension: '.pages', type: 'document', previewable: false },
    { extension: '.numbers', type: 'document', previewable: false },
    { extension: '.key', type: 'document', previewable: false },
    { extension: '.wpd', type: 'document', previewable: false },
    { extension: '.tex', type: 'document', previewable: false },
    { extension: '.bib', type: 'document', previewable: false },
    { extension: '.ps', type: 'document', previewable: false },
    { extension: '.xps', type: 'document', previewable: false },
    { extension: '.html', type: 'document', previewable: false },
    { extension: '.htm', type: 'document', previewable: false },
    { extension: '.xml', type: 'document', previewable: false },
    { extension: '.json', type: 'document', previewable: false },
    { extension: '.yml', type: 'document', previewable: false },
    { extension: '.yaml', type: 'document', previewable: false },
    { extension: '.log', type: 'document', previewable: false },
    { extension: '.msg', type: 'document', previewable: false },
    { extension: '.eml', type: 'document', previewable: false },
    { extension: '.mobi', type: 'document', previewable: false },
    { extension: '.azw', type: 'document', previewable: false },
    { extension: '.azw3', type: 'document', previewable: false },
    { extension: '.fb2', type: 'document', previewable: false },
    { extension: '.djvu', type: 'document', previewable: false },
    { extension: '.odm', type: 'document', previewable: false },
    { extension: '.ott', type: 'document', previewable: false },
    { extension: '.dot', type: 'document', previewable: false },
    { extension: '.dotx', type: 'document', previewable: false },
    { extension: '.xlsm', type: 'document', previewable: false },
    { extension: '.pptm', type: 'document', previewable: false },
    { extension: '.vsd', type: 'document', previewable: false },
    { extension: '.vsdx', type: 'document', previewable: false },
    { extension: '.one', type: 'document', previewable: false },
    { extension: '.qxd', type: 'document', previewable: false },
    { extension: '.qxp', type: 'document', previewable: false },
    { extension: '.abw', type: 'document', previewable: false },
    { extension: '.gdoc', type: 'document', previewable: false },
    { extension: '.gsheet', type: 'document', previewable: false },
    { extension: '.gslides', type: 'document', previewable: false },
    { extension: '.gdraw', type: 'document', previewable: false },
    { extension: '.gdform', type: 'document', previewable: false },
];

export function isTransferFilePreviewable(file: GetTransferFilePreviewOutput['file']): boolean {
    return !!previewableTransferFile.find(item => item.extension === file.ext && item.previewable);
}

export function getTransferFileTypeFromExtension(extension: string): TransferFileType {
    const media = previewableTransferFile.find(media => media.extension === extension);
    if (!!media) {
        return media.type;
    }
    return 'unknown';
}

export function getTransferFileProviderFromUrl(type: TransferFileType): TransferFileProvider | null {
    if (type === 'audio' || type === 'video') {
        return 'html5';
    }
    return null;
}

export function addMetadataToFile(file: GetTransferFilePreviewOutput['file'], isPreviewEnabled: boolean): TransferFile {
    const type = getTransferFileTypeFromExtension(file.ext);
    const transferFile: TransferFile = {
        ...file,
        previewable: isPreviewEnabled ? isTransferFilePreviewable(file) : false,
        type,
        provider: getTransferFileProviderFromUrl(type),
    }

    return transferFile;
}
